
export default {
  attendancespermonth2d:[],
  employees: [],
  attendances: [],
  attendancesbasicdata: [],
  attendancespermonth:[],
  summarypermonth0: [],
  summarypermonth1: [],
  summarypermonth2: [],
  usages:[]
}
